import { Autocomplete, type TextFieldProps } from '@all-manager/design-system-v2';
import { useGetSuggestedContactNames } from "../../features/topics/api/useGetSuggestedContactNames";

type Props = Pick<TextFieldProps, 'label' | 'helperText' | 'error' | 'required' | 'autoFocus' | 'fullWidth' | 'size' | 'disabled' | 'placeholder'> & {
  value: string;
  onChange: (value: string) => void;
}

export default function ContactNameAutocomplete(props: Props) {
  const { data: contactNames } = useGetSuggestedContactNames();

  return (
    <Autocomplete<string, false, false, true>
      freeSolo
      options={contactNames?.flatMap((p) => (p.contact_name ? [p.contact_name] : [])) ?? []}
      value={props.value}
      onChange={(_event, value) => props.onChange(value ?? '')}
      onInputChange={(_event, value, reason) => {
        if (reason === 'input' || reason === 'clear') {
          props.onChange(value);
        }
      }}
      label={props.label}
      helperText={props.helperText}
      error={props.error}
      required={props.required}
      autoFocus={props.autoFocus}
      placeholder={props.placeholder}
      fullWidth={props.fullWidth}
      size={props.size}
      disabled={props.disabled}
    />
  );
}
